export default function CoreSpaces() {
  const spaces = [
    {
      title: 'مساحات العمل المفتوحة',
      description: 'اشتراك مفتوح ومكاتب ثابتة ومكاتب فرق',
      image: '/space-open.png',
      fallback: 'https://via.placeholder.com/400x300/FF6B6B/FFFFFF?text=Open+Workspace'
    },
    {
      title: 'مكاتب خاصة للشركات الناشئة',
      description: 'مساحات مخصصة للفرق والمشاريع الناشئة',
      image: '/space-private.png',
      fallback: 'https://via.placeholder.com/400x300/FF8E53/FFFFFF?text=Private+Offices'
    },
    {
      title: 'غرف التدريب',
      description: 'برامج تدريب وورش مهارية وجلسات إرشاد مهني',
      image: '/space-training.png',
      fallback: 'https://via.placeholder.com/400x300/FFA07A/FFFFFF?text=Training+Rooms'
    },
    {
      title: 'غرف التفكير والابتكار',
      description: 'غرف تصميم وجلسات عصف ذهني',
      image: '/space-innovation.png',
      fallback: 'https://via.placeholder.com/400x300/FFB88C/FFFFFF?text=Innovation+Rooms'
    },
    {
      title: 'مناطق الاسترخاء الذكي',
      description: 'مناطق استرخاء وألعاب ذهنية وفعاليات اجتماعية',
      image: '/space-relaxation.png',
      fallback: 'https://via.placeholder.com/400x300/667EEA/FFFFFF?text=Relaxation+Zones'
    },
    {
      title: 'المقهى الإبداعي',
      description: 'مساحة للتواصل والإلهام',
      image: '/space-cafe.png',
      fallback: 'https://via.placeholder.com/400x300/764BA2/FFFFFF?text=Creative+Cafe'
    },
    {
      title: 'استوديو المحتوى',
      description: 'بودكاست وتصوير محتوى احترافي',
      image: '/space-studio.png',
      fallback: 'https://via.placeholder.com/400x300/F093FB/FFFFFF?text=Content+Studio'
    },
    {
      title: 'مساحات عرض وفعاليات',
      description: 'قاعات للفعاليات والعروض التقديمية',
      image: '/space-events.png',
      fallback: 'https://via.placeholder.com/400x300/4FACFE/FFFFFF?text=Event+Space'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-[#FFF5F3] to-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            المساحات والخدمات الأساسية
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-4">
            بيئة متكاملة مصممة لدعم كل جانب من جوانب رحلة الابتكار
          </p>
          <div className="inline-block bg-gradient-to-r from-[#FF6B6B]/10 to-[#FF8E53]/10 px-8 py-4 rounded-2xl border border-[#FF6B6B]/20">
            <p className="text-lg font-semibold text-gray-800">
              نحن لا نوفر مكانًا للعمل، بل نخلق بيئة تُنتج الأفكار وتُطلق المسارات المهنية
            </p>
          </div>
        </div>

        {/* Spaces Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {spaces.map((space, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 bg-white"
            >
              <div className="relative h-48 bg-gradient-to-br from-gray-100 to-gray-200 overflow-hidden">
                <div className="relative w-full h-full group-hover:scale-110 transition-transform duration-500">
                  <img
                    src={space.image}
                    alt={space.title}
                    className="w-full h-full object-cover object-center"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = space.fallback;
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-bold text-xl text-gray-900 mb-2">
                  {space.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {space.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}